import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

export type ProductCategory =
  | 'laptops'
  | 'consoles'
  | 'tablets'
  | 'smartwatches'
  | 'smartphones'

export type ProductCategories = Array<{
  id?: Maybe<string>
  technicalName?: Maybe<string>
  name?: Maybe<ProductCategory>
}>

export const ProductCategoriesSchema = z.array(
  z.object({
    id: z.nullish(z.string()),
    technicalName: z.nullish(z.string()),
    name: z.nullish(
      z.enum(['laptops', 'consoles', 'tablets', 'smartwatches', 'smartphones']),
    ),
  }),
)

/* Schemas validation */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type TestProductCategories = ExpectTrue<
  Equal<ProductCategories, z.infer<typeof ProductCategoriesSchema>>
>
